
import { defineComponent, PropType } from 'vue'
import { getLocalization } from '../../helper/c-translation-helper'
import { LocalizationData, LocalizationPath } from '../../../../../../core/src'
import { LocalizationService } from '../../../../../core/src'
import { ButtonFactory } from '../../components/c-button/button.factory'
import CButton from '../../components/c-button/c-button.component.vue'
import { IButton } from '../../components/c-button/interface/i-button'
import CModal from '../c-modal/c-modal.component.vue'
import { IAlertModalProps } from './interface/i-alert-modal-props'

interface ISetup {
  closeButton: IButton
  methods: IMethod
}

interface IMethod {
  confirm: () => void
}

/**
 * Custom Confirmation modal.
 */
export default defineComponent({
  components: {
    CModal,
    CButton,
  },
  props: {
    modalProps: {
      type: Object as PropType<IAlertModalProps>,
      required: true,
    },
    App: {
      type: Object as PropType<any>,
      required: true
    }
  },
  setup(props, { emit }): ISetup {
    const localization: LocalizationData = getLocalization(props.App)
    const closeButton = ButtonFactory.button({
      classes: 'theme-shades-light1-white row-center-fullwidth align-center g-10 btn-md',
      label: LocalizationService.t<string>(localization, LocalizationPath.closeBtn),
      width: '150px',
      cyTag: 'alert-modal-close-btn',
    })

    const methods: IMethod = {
      /**
       * Emits a confirm event from the modal. Can be used by the parent to perform an action after confirmation.
       * @remarks This confirms that whatever action was being confirmed by the parent was accepted by the user,
       * and the parent component should proceed with further actions.
       */
      confirm: (): void => {
        emit('confirm')
      }
    }

    return {
      closeButton,
      methods
    }
  }
})
